// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"233ce3f1481d140f16de","263":"6356364dcd9f2a9c921d","791":"ed6f495c8f862fcadb48"}[chunkId] + ".js";
};